<template>
  <div class="fullscrean text-muted">
    <div>
      <div><img src="../assets/logo-lecard.png" alt="Logo Lecard" style="width: 72px"></div>
      <div class="mt-2 mb-4">
        Para continuar clique em "Acessar Gestor".
      </div>
      <a :href="`https://beta.gestor.lecard.delivery?auth=${token}`" class="btn btn-primary" @click="load = true" v-if="!isElectron">
        {{ load ? 'Aguarde..' : 'Acessar Gestor' }}
      </a>
      <button class="btn btn-primary" @click="toggleAmbiente()" v-else>
        {{ load ? 'Aguarde..' : 'Acessar Gestor' }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Ambiente',
    data() {
      return {
        token: localStorage.getItem('key'),
        load: false
      }
    },

    methods: {
      toggleAmbiente() {
        document.dispatchEvent(new CustomEvent('setAmbiente', { detail: !this.is_beta ? '2' : '' }));

        if (this.electronV < 190) {
          window.location.href = `https://beta.gestor.lecard.delivery?auth=${this.token}`;
        }
      }
    }
  }
</script>

<style scoped>
.fullscrean {
  display: flex;
  height: 96vh;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  text-align: center;
}

@media (max-height: 550px) {
  .fullscrean {
    height: auto;
    margin-top: 130px;
  }
}
</style>
